import { store } from '../../src/store/store'
import ConfigurationService from '../components/configuration/configuration.service'
import { CONSTANT, SDK_IDS } from '../utils/constant.js'
import _ from 'lodash'
import toasterService from './toaster'
import messages from '../messages'
import orchestration from '../orchestration'
import checkout from './checkout'
import { EventBus } from '../event-bus'
import sanitize from '@/utils/sanitize'
import encrypt from '@/utils/encrypt'
import traceService from '../components/shared/trace/trace-service.js'

let srcWindow = {}
let authUIPopup = {}
let srciPopupCloseTimer
let authUIPopupCloseTimer
let loadedSdkImages = []
const configurationService = new ConfigurationService()

const sharedService = {

  intializeSdk () {
    store.commit('resetLightbox')
    let dpaTransactionOptions = this.getDpaTransactionOptions()
    return new Promise(resolve => {
      orchestration.callMethod({ methodName: CONSTANT.TRACE.METHOD.INIT, methodParameters: { dpaTransactionOptions } }).then(() => {
        orchestration.callMethod({ methodName: CONSTANT.TRACE.METHOD.ISRECOGNIZED }).then(isRecognizedResponse => {
          store.commit('recognized', isRecognizedResponse)
          resolve()
        })
      })
    })
  },

  /**
   * get Dpa Transaction Options
   * @returns {{transactionType, dpaAcceptedShippingCountries, consumerEmailAddressRequested, dpaShippingPreference, consumerNameRequested, transactionAmount, consumerPhoneNumberRequested, dpaAcceptedBillingCountries, dpaLocale, dpaBillingPreference}}
   */
  getDpaTransactionOptions () {
    return {
      transactionAmount: {
        transactionAmount: store.getters.transactionAmount,
        transactionCurrencyCode: store.getters.currency
      },
      transactionType: CONSTANT.TRANSACTION_TYPE,
      dpaBillingPreference: store.getters.billingAddress,
      dpaShippingPreference: store.getters.shippingAddress,
      ...(store.getters.mastercardDcfPreference !== 'NONE') && { customInputData: {
        'com.mastercard.dcfExperience': store.getters.mastercardDcfPreference
      } },
      consumerNationalIdentifierRequested: store.getters.nationalIdentifierPreference,
      dpaAcceptedBillingCountries: store.getters.billingCountryCodes,
      dpaAcceptedShippingCountries: store.getters.shippingCountryCodes,
      dpaLocale: store.getters.preferredLocale,
      consumerEmailAddressRequested: store.getters.consumerEmailAddressRequested,
      consumerNameRequested: store.getters.consumerNameRequested,
      consumerPhoneNumberRequested: store.getters.consumerPhoneNumberRequested,
      confirmPayment: store.getters.checkout.confirmPayment,
      ...(store.getters.threeDSPreference) && { threeDsPreference: store.getters.threeDSPreference }
    }
  },

  openAuthUI (authURl, sav, calledFrom) {
    const popUpClose = {
      from: calledFrom,
      type: 'Error'
    }
    const url = `${new URL(authURl)}`
    const { width, height } = sharedService.getResolution()
    authUIPopup = window.open(url, '_blank', 'popup')
    let left = (screen.width - width) / 2
    let top = (screen.height - height) / 2
    if (left <= 0 || top <= 0) {
      left = 600
      top = 200
    }
    authUIPopup.moveTo(left, top)
    authUIPopup.resizeTo(width, height)
    window.authUIWindow = authUIPopup
    authUIPopupCloseTimer = setInterval(function () {
      if (!window.authUIWindow || window.authUIWindow.closed) {
        EventBus.$emit('authUIResponse', popUpClose)
      }
    }, 500)
    window.addEventListener('message', sharedService.handleMessageFromAuthUIChildWindow)
    store.dispatch('lightBoxloaderOn', true)
  },

  closeAuthUIPopup () {
    if (window?.authUIWindow) {
      store.dispatch('lightBoxloaderOn', false)
      window.authUIWindow.close()
    }
  },
  handleMessageFromAuthUIChildWindow (event) {
    clearInterval(authUIPopupCloseTimer)
    if (event.source === authUIPopup) {
      if (event.data?.payload?.authenticationStatus === 'CANCELLED') {
        EventBus.$emit('authUIResponse', event.data.payload.authenticationResult)
      }
      if (event.data.result) {
        window.removeEventListener('message', sharedService.handleMessageFromAuthUIChildWindow)
        sharedService.closeAuthUIPopup()
        EventBus.$emit('authUIResponse', event.data.result)
      }
    }
  },

  /**
   * invoke popup window to load SRCi UI
   * @param router
   * @param invokedFrom
   * @param store
   */
  invokeSrc (router, invokedFrom, store) {
    store.dispatch('lightBoxloaderOn', false)
    window.checkout = checkout
    const uri = (invokedFrom === CONSTANT.SRC.INLINE_CARD) ? '/srci/addcard' : '/srci'
    if (router) {
      let routeData = router.resolve({
        name: uri
      })
      srcWindow = window.open(routeData.route.name, '_blank', 'popup')
    } else {
      srcWindow = window.open('', '_blank', 'popup')
    }
    const { width, height } = this.getResolution()
    let left = (screen.width - width) / 2
    let top = (screen.height - height) / 2
    if (left <= 0 || top <= 0) {
      left = 600
      top = 200
    }
    srcWindow.moveTo(left, top)
    srcWindow.resizeTo(width, height)
    window.childSrcWindow = srcWindow
    srciPopupCloseTimer = setInterval(function () {
      if (!window.childSrcWindow || window.childSrcWindow.closed) {
        sharedService.updateOnSrciPopupClose()
        window.location.reload()
      }
    }, 1000)
    window.addEventListener('message', sharedService.handleMessageFromChildWindow)
    store.dispatch('updateSRCTotalPrice', invokedFrom)
    store.dispatch('loaderOn', true)
  },

  handleMessageFromChildWindow (event) {
    if (event.source === srcWindow) {
      if (event.data.recognitionToken) {
        store.commit('setRecognitionToken', event.data.recognitionToken)
      }
      if (event.data.rememberMe) {
        store.commit('setRememberMeValue', event.data.rememberMe)
      }
      if (event.data.profileOptOut) {
        store.commit('setProfileOptOut', event.data.profileOptOut)
      }
    }
  },

  verifyEmailId (emailId) {
    // eslint-disable-next-line
    let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
    if (regex.test(emailId)) {
      return true
    } else {
      return false
    }
  },

  /**
   * cancel SRCi window
   * @param event
   */
  cancel (event) {
    if (event.data && event.data.cancel) {
      store.dispatch('loaderOn', false)
    }
  },

  /**
   * load default src configs based on env
   * @param env
   * @returns {Promise<void>}
   */
  async loadInitialSrcConfiguration (env) {
    try {
      if (!configurationService.getMasterCardSrcEntity()) {
        await this.updateSrcConfig(env)
      }
    } catch (error) {
      console.error(error)
      configurationService.SRCIEntityID = ''
      configurationService.DpaId = ''
    }
  },

  /**
   * load src config when changes in env
   * @param env
   * @returns {Promise<void>}
   */
  async loadSrcConfiguration (env) {
    try {
      await this.updateSrcConfig(env)
    } catch (error) {
      console.error(error)
      this.updateSrcEntityIds([])
      this.updateDpaIds([])
    }
  },

  /**
   * update SRC configs
   * @param env
   * @returns {Promise<void>}
   */
  async updateSrcConfig (env) {
    const srcEntityIds = await configurationService.loadSrcConfiguration(env)
    const dpaIds = []
    let startSrcEntityIds = srcEntityIds.filter(item => item.mttConfigId.includes('START'))
    this.updateSrcEntityIds(startSrcEntityIds)
    this.updateSrcEntityId(startSrcEntityIds[0])
    _.forEach(startSrcEntityIds, dpaID => {
      dpaIds.push(...dpaID.dpaConfigs)
    })
    this.updateDpaIds(dpaIds)
    this.updateDpaId(dpaIds[0])
  },

  /**
   * Load API EndPoint
   * @param environmentId
   * @returns {Promise<void>}
   */
  async loadApiEndPoint (environmentId) {
    try {
      let response = await configurationService.getApiEndPoints(environmentId)
      if (response) {
        await store.dispatch('updatePaymentProcessor', JSON.parse(JSON.stringify(response)))
      }
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * @param environmentId
   * @returns {Promise<void>}
   */
  async loadSrcKeys (environmentId) {
    try {
      let response = await configurationService.getSrcKeys(environmentId)
      if (response) {
        await store.dispatch('updateKeysByEnv', response)
      }
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * This method get the federated Id Result i.e. isRecognized should always true and
   * append the JWT which get from Masterpass MTT
   * @param result
   * @returns {*}
   */
  getFederatedIdResult (result) {
    if (result.recognized === false) {
      result.recognized = true
      let token = []
      token.push(store.state.configuration.federatedToken)
      result.idTokens = token
    } else if (result.recognized === true) {
      result.idTokens.push(store.state.configuration.federatedToken)
    }
    return result
  },

  /**
   * get Initiator IDS and DPA ids
   * for all sdk as an object
   * @returns {{}}
   */
  getAllInitiatorAndDpaIds () {
    let initiatorAndDpaIds = {}
    Object.keys(SDK_IDS).forEach((sdkId, sdkKey) => {
      initiatorAndDpaIds[sdkId] = {
        srcInitiatorId: configurationService.getSrcInitiatorId(sdkKey),
        srciDpaId: configurationService.getDpaId(sdkKey)
      }
    })
    return initiatorAndDpaIds
  },

  /**
   * Get Standard SRC Inputs based on
   * srcCorrelationId and srcNetwork
   * @param srcCorrelationId,
   * @param srcNetwork
   * @returns {*}
   */
  getStandardSrcInputs (srcCorrelationId, srcNetwork) {
    return {
      environmentId: configurationService.getSelectedEnvironment(),
      srciType: null,
      srciClientId: store.getters.checkoutType === 'DUAL_MODEL' ? store.getters.selectedNonPaymentSrci : configurationService.getSrcInitiatorId(0, srcNetwork.toLowerCase()),
      srcDsaId: configurationService.getDpaId(0, srcNetwork.toLowerCase()),
      srcCorrelationId: srcCorrelationId,
      srcTransactionId: store.getters.srcTransactionId,
      srcRecipientKeyId: store.getters.checkoutType !== 'NONE' ? configurationService.getSrcInitiatorId(0, srcNetwork.toLowerCase()) : null,
      srcNetwork: srcNetwork,
      sscMode: store.getters.checkoutType !== 'NONE' ? store.getters.checkoutType.split('_')[0] : 'NONE'
    }
  },

  /**
   * @param srcCorrelationId
   * @returns {Promise<{standardSrcInputs: *, confirmationInput: {confirmationRequest: {confirmationData:
   * {transactionAmount: {transactionAmount: *, transactionCurrencyCode: *}}}}}>}
   */
  async confirmationData (srcCorrelationId, srcNetwork) {
    const standardSrcInputs = sharedService.getStandardSrcInputs(srcCorrelationId, srcNetwork)
    const confirmationData = {
      transactionAmount: {
        transactionAmount: store.getters.totalItems === 0 ? store.getters.cartTotalPrice : store.getters.totalPrice,
        transactionCurrencyCode: store.getters.currencyCode
      }
    }
    if (store.state.configuration.decryptedPayload.assuranceData) {
      confirmationData.assuranceData = store.state.configuration.decryptedPayload.assuranceData
    }
    return {
      standardSrcInputs,
      confirmationInput: {
        confirmationRequest: {
          confirmationData
        }
      }
    }
  },

  /**
   * @param srcCorrelationId
   * @returns {Promise<*|Promise<T | never>>}
   */
  async confirmation (srcCorrelationId, srcNetwork) {
    let confirmationData = await this.confirmationData(srcCorrelationId, srcNetwork)
    return configurationService.getConfirmationData(confirmationData)
  },

  /**
   * loading dynamic script and necessary action on fail
   * @param scriptUrl
   * @param srcNetwork
   * @returns {Promise<unknown>}
   */
  loaderScript (scriptUrl, srcNetwork = '') {
    console.log(`${srcNetwork} SDK loading Again`)
    return new Promise((resolve) => {
      let script = document.createElement('script')
      script.src = scriptUrl
      script.type = 'text/javascript'
      script.id = srcNetwork.toLowerCase() + 'SDK'
      let timerId = setTimeout(() => {
        console.warn(srcNetwork + messages['en-US'].errorMessages.SDK_LOAD_TIMEOUT + ' in 10 Seconds.')
        resolve()
      }, 10000)
      script.onload = () => {
        this.loadSdkLogo(srcNetwork)
        clearTimeout(timerId)
        resolve()
      }
      script.onerror = () => {
        toasterService.onFailure(srcNetwork + messages['en-US'].errorMessages.SDK_LOAD)
        clearTimeout(timerId)
        resolve()
      }
      document.head.appendChild(script)
    })
  },

  /**
   * This method will load sdk logo images
   * @param srcNetwork
   */
  loadSdkLogo (srcNetwork) {
    loadedSdkImages.push(srcNetwork.toLowerCase())
    this.sortSdkLogo()
    store.commit('loadedSDKs', loadedSdkImages)
  },

  /**
   * This method will sort sdk logo images
   */
  sortSdkLogo () {
    const sortingObj = { 'mastercard': 1, 'visa': 2, 'amex': 3, 'discover': 4 }
    loadedSdkImages.sort((val1, val2) => {
      if (sortingObj[val2] === sortingObj[val1]) {
        return 0
      } else if (sortingObj[val2] < sortingObj[val1]) {
        return 1
      } else {
        return -1
      }
    })
  },

  srciScreenChange (screenName, router) {
    if (!window.opener) {
      EventBus.$emit('switchPage', CONSTANT.INLINE_SCREEN[screenName])
    } else {
      let screenUri = CONSTANT.SCREEN_URI[screenName]
      router.push(screenUri).catch(err => { console.error(err) })
    }
  },

  /**
   * Update SrcEntityId
   * @param response
   */
  updateSrcEntityId (srcEntityId) {
    store.commit('updateSrcEntityId', srcEntityId)
  },

  /**
   * Update Entity Id's
   * @param response
   */
  updateSrcEntityIds (srcEntityIds) {
    store.commit('updateSrcEntityIds', srcEntityIds)
    this.updateSelecteNonPaymentSrci(store.getters.checkoutType)
  },

  /**
   * Update Dpa ID's
   * @param response
   */
  updateDpaId (dpaId) {
    store.commit('updateDpaId', dpaId)
  },

  /**
   * Update Dpa ID's
   * @param response
   */
  updateDpaIds (dpaIds) {
    store.commit('updateDpaIds', dpaIds)
  },

  /**
   * Unmask the value passed
   * @param val
   * @returns {*}
   */
  unmask (val) {
    if (val) {
      return val.replace(/\D+/g, '')
    }
  },

  generateUUID () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
  },

  /**
   * Disable Confirmation Button
   */
  disableConfirmationButton () {
    store.commit('updateEnableConfirmation', false)
  },

  /**
   * enable checkout button while changing state
   */
  updateCheckoutButton () {
    return store.commit('updateIsSRCCheckoutDisabled', true)
  },

  updateConsumerBillingAddress (billingAddressPreference) {
    let consumerBillingAddress = store.getters.consumerBillingAddress
    if (billingAddressPreference === 'POSTAL_COUNTRY') {
      consumerBillingAddress = {
        name: consumerBillingAddress.name,
        countryCode: consumerBillingAddress.countryCode,
        zip: consumerBillingAddress.zip
      }
    } else if (billingAddressPreference === 'NONE') {
      consumerBillingAddress = {
        name: consumerBillingAddress.name
      }
    }
    consumerBillingAddress = sanitize(consumerBillingAddress)
    store.commit('changeConsumerBillingAddress', consumerBillingAddress)
  },

  /**
   * This method update the SRC checkout flag to enable/ disable checkout button
   */
  enableSRCCheckOut () {
    store.commit('lightBoxloaderOn', false)
    store.commit('updateIsSRCCheckoutDisabled', false)
  },

  /**
   * Masked Email while displaying validation data
   * @param userId
   * @returns {string}
   */
  maskedEmail (userId) {
    let arr = userId.split('@')
    return this.censorWord(arr[0]) + '@' + this.censorWord(arr[1])
  },

  /**
   * censor word i.e. masked word replaced by '*'
   * @param str
   * @returns {string}
   */
  censorWord (str) {
    return str[0] + '*'.repeat(str.length - 2) + str.slice(-1)
  },

  /**
   * Delete existing sdk script
   * @param id
   */
  deleteScript (id) {
    const currentScript = document.querySelector(id)
    if (currentScript) {
      currentScript.parentNode.removeChild(currentScript)
    }
  },

  updateOnSrciPopupClose () {
    store.commit('updateIsSRCCheckoutDisabled', true)
    store.commit('setRememberMeValue', false)
    store.commit('loaderOn', false)
    store.commit('resetLightbox')
    window.removeEventListener('message', sharedService.handleMessageFromChildWindow)
    clearInterval(srciPopupCloseTimer)
  },

  clearStore () {
    store.commit('setScofExecutionFlow', '')
    store.commit('setEnrollMaskCard', {})
    store.commit('setMdesAuthenticateResponse', '')
    store.commit('setScofReturningInfo', '')
    store.commit('setAuthResponse', '')
    store.commit('setTavInfo', '')
    store.commit('setThirdPartyFIDO', false)
    store.commit('setThirdPartyPKI', false)
    store.commit('setConsumerContactInfo', '')
  },

  async encryptCard (cardDetails, encKeyId, srcNetworkKeys, isLogged) {
    const encParam = {
      encContentAlgo: CONSTANT.PAN_ENC.ENCRYPTION_CONTENT_ALGO,
      encAlgo: CONSTANT.PAN_ENC.ENC_ALGO,
      encKeyId: encKeyId,
      keys: srcNetworkKeys
    }
    delete cardDetails.network
    if (isLogged) {
      traceService.addRequestLogs({
        methodName: 'encryptCard',
        params: cardDetails
      })
    }
    let encryptedCard = await encrypt.encryptCard(cardDetails, encParam)
    cardDetails.encryptedCard = encryptedCard
    if (isLogged) {
      traceService.addResponseLogs('encryptCard', { encryptedCard: encryptedCard })
    }

    return encryptedCard
  },

  /**
   * close SRCi window
   */
  close () {
    store.commit('loaderOn', false)
  },

  /**
   * Validate New card before checkout
   * @param cardDetails
   * @returns {boolean}
   */
  validateCardDetails (cardDetails) {
    let expiryDate = cardDetails.panExpirationMonth + '/' + cardDetails.panExpirationYear.toString().substr(2, 2)
    if (!cardDetails.primaryAccountNumber || (cardDetails.primaryAccountNumber.length > 0 && cardDetails.primaryAccountNumber.length < 15) || !cardDetails.network) {
      return false
    } else if (this.validateExpiryDate(expiryDate)) {
      return false
    } else if (this.validateCVV(cardDetails.cardSecurityCode)) {
      return false
    } else {
      return true
    }
  },

  /**
   * validate expiry date
   */
  validateExpiryDate (expiryDate) {
    if (expiryDate && expiryDate.length !== 5) {
      return true
    } else {
      let todayDate = new Date()
      let expiryMonth = expiryDate.split('/')[0]
      let expiryYear = expiryDate.split('/')[1] || ''
      let currentMonth = (todayDate.getMonth() + 1)
      let currentYear = todayDate.getFullYear().toString().substr(-2)
      expiryMonth = parseInt(expiryMonth, 10)
      if (expiryYear < currentYear) {
        return true
      } else if (expiryYear === currentYear && expiryMonth < currentMonth) {
        return true
      } else {
        return false
      }
    }
  },

  /**
   * validate cvv
   * @param cvv
   * @returns {boolean}
   */
  validateCVV (cvv = '') {
    if (!cvv || (cvv.length < 3 || cvv.length > 4)) {
      return true
    } else {
      return false
    }
  },

  getScofInputs (payloadResponse) {
    let scofInputs = {
      'consumer': {
        'firstName': payloadResponse.maskedConsumer.maskedFirstName,
        'lastName': payloadResponse.maskedConsumer.maskedLastName,
        'emailAddress': payloadResponse.maskedConsumer.maskedEmailAddress,
        'mobileNumber': {
          'phoneNumber': payloadResponse.maskedConsumer.maskedConsumerMobileNumber.phoneNumber,
          'countryCode': payloadResponse.maskedConsumer.maskedConsumerMobileNumber.countryCode
        },
        'countryCode': payloadResponse.shippingCountryCode,
        'fullName': payloadResponse.maskedConsumer.maskedFirstName + ' ' + payloadResponse.maskedConsumer.maskedLastName,
        'nationalIdentifier': null,
        'languageCode': 'en',
        'consumerIdentity': {
          'identityType': 'EXTERNAL_ACCOUNT_ID',
          'identityValue': payloadResponse.maskedConsumer.maskedEmailAddress,
          'identityProvider': 'SRC'
        }
      },
      'cardSource': 'MERCHANT',
      'complianceSettings': store.getters.complianceSettingsObj,
      'encryptedCard': '',
      'shippingAddress': payloadResponse.maskedCard.shippingAddress,
      'consumerEmailAddress': payloadResponse.maskedConsumer.maskedEmailAddress,
      'consumerFirstName': payloadResponse.maskedConsumer.maskedFirstName,
      'consumerLastName': payloadResponse.maskedConsumer.maskedLastName,
      'consumerFullName': payloadResponse.maskedConsumer.maskedFirstName + ' ' + payloadResponse.maskedConsumer.maskedLastName,
      'consumerMobileNumber': {
        'countryCode': payloadResponse.maskedConsumer.maskedConsumerMobileNumber.countryCode,
        'phoneNumber': payloadResponse.maskedConsumer.maskedConsumerMobileNumber.phoneNumber
      },
      'billingAddress': payloadResponse.maskedCard.billingAddress
    }
    return scofInputs
  },

  updateSelecteNonPaymentSrci (checkoutMethod) {
    if (store.getters.nonPaymentSrci.length === 0) {
      return
    }
    switch (checkoutMethod) {
      case 'DUAL_MODEL' : {
        let selectedNonPaymentSrci
        let dualNonPaymentSrci = store.getters.nonPaymentSrci.find(item => item.mttConfigId.includes('DUAL'))
        if (dualNonPaymentSrci) {
          selectedNonPaymentSrci = dualNonPaymentSrci.srci[0].srcInitiatorId
        } else {
          selectedNonPaymentSrci = store.getters.nonPaymentSrci[0].srci[0].srcInitiatorId
        }
        store.dispatch('updateSelectedNonPaymentSrci', selectedNonPaymentSrci)
        break
      }
      case 'PULL_MODEL' : {
        let selectedNonPaymentSrci
        let pullNonPaymentSrci = store.getters.nonPaymentSrci.find(item => item.mttConfigId.includes('PULL'))
        if (pullNonPaymentSrci) {
          selectedNonPaymentSrci = pullNonPaymentSrci.srci[0].srcInitiatorId
        } else {
          selectedNonPaymentSrci = store.getters.nonPaymentSrci[0].srci[0].srcInitiatorId
        }
        store.dispatch('updateSelectedNonPaymentSrci', selectedNonPaymentSrci)
        break
      }
      default : {
        store.dispatch('updateSelectedNonPaymentSrci', null)
        break
      }
    }
  },

  async loadScript (src, sdkName) {
    return new Promise((resolve, reject) => {
      const existingScript = document.getElementById(sdkName.toLowerCase() + 'SDK')
      if (existingScript) {
        document.head.removeChild(existingScript)
        delete window.AUTHSDK_MASTERCARD
      }
      const script = document.createElement('script')
      script.src = src
      script.id = sdkName.toLowerCase() + 'SDK'
      script.onload = () => {
        resolve(script)
      }

      script.onerror = () => {
        reject(new Error(`Script load error for ${src}`))
      }

      document.head.append(script)
    })
  },

  removeScriptById (id) {
    const script = document.getElementById(id)
    if (script) script.parentElement.removeChild(script)
  },

  async getBindMfaApiResponse (reqBody, param) {
    const response = await configurationService.getBindMfaApiResponse(reqBody, param)
    return Promise.resolve(response)
  },

  async getScofPayloadApiResponse (reqBody) {
    const response = await configurationService.getScofPayloadApiResponse(reqBody)
    return Promise.resolve(response)
  },

  async getB2BAuthLookupApiResponse (reqBody) {
    const response = await configurationService.getB2BAuthLookupApiResponse(reqBody)
    return Promise.resolve(response)
  },

  async getTAVGenerateApiResponse (reqBody) {
    const response = await configurationService.getTAVGenerateApiResponse(reqBody)
    return Promise.resolve(response)
  },

  async getB2BAuthenticateApiResponse (reqBody) {
    const response = await configurationService.getB2BAuthenticateApiResponse(reqBody)
    return Promise.resolve(response)
  },

  async getSavedCardDetails (reqBody) {
    const response = await configurationService.getCardDetails(reqBody)
    return Promise.resolve(response)
  },

  async getScofResultApiResponse (reqBody) {
    const response = await configurationService.getScofResultApiResponse(reqBody)
    return Promise.resolve(response)
  },

  async getThirdPartyPKIData (reqBody) {
    const response = await configurationService.getThirdPartyPKIData(reqBody)

    return Promise.resolve(response)
  },

  checkFeatureFlag (feature) {
    const toggleMacsFeaturesList = store.getters.toggleMacsFeaturesList
    const featureValue = toggleMacsFeaturesList[feature]

    if (typeof featureValue === 'boolean') {
      return featureValue
    } else if (Array.isArray(featureValue)) {
      const flagParameters = {}
      featureValue
        .filter(item => item.enabled === true)
        .forEach(item => {
          flagParameters[item.name] = item.value
        })
      return flagParameters
    }
    return false
  },

  resetUserInformation () {
    store.commit('setThirdPartyFIDO', false)
    store.commit('setThirdPartyPKI', false)
    store.commit('setPkiFormat', 'none')
    store.commit('setTavInfo', '')
    store.commit('setTraceId', null)
  },

  setAppInstanceId () {
    if (!localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)) {
      localStorage.setItem(CONSTANT.APP_INSTANCE_KEY, this.generateUUID())
    }
  },

  getAppInstanceId () {
    return this.generateUUID()
  },

  getResolution () {
    if (window.screen.width < 768) {
      return {
        'width': 432,
        'height': 620
      }
    } else {
      return {
        'width': 550,
        'height': 760
      }
    }
  }
}

export default sharedService
